var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPebLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 -1 255 150.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wordmark"
  }, /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 100,
    fontFamily: "'Montserrat', sans-serif",
    fontSize: 110,
    fontWeight: "bold",
    fill: "currentColor",
    letterSpacing: 4
  }, "PEB"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "subtext"
  }, /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 128,
    fontFamily: "'Montserrat', sans-serif",
    fontSize: 14.5,
    fontWeight: 600,
    fill: "currentColor",
    letterSpacing: 1.8
  }, "PERSONALENTWICKLUNGS-"), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 146,
    fontFamily: "'Montserrat', sans-serif",
    fontSize: 14.5,
    fontWeight: 600,
    fill: "currentColor",
    letterSpacing: 1.8
  }, "UND BEURTEILUNGSSYSTEM"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPebLogo);
export default __webpack_public_path__ + "static/media/peb-logo.b2d932f3bf0988bff78870974309f9c0.svg";
export { ForwardRef as ReactComponent };